

import './BusinessTable.css';
import blocked from '../../assets/images/Business_List_Blocked_Button.png';
import unblocked from '../../assets/images/Business_List_Unblocked_Button.png';
import whatsApp from '../../assets/images/Business_List_Whatsapp_Button.png';
import { Business } from '../../Items/Business';
import { useDispatch, useSelector } from 'react-redux';
import { toggleIsShow } from '../../Services/BusinessService';



interface BusinessTableProps {
  onRowClick: (business: Business) => void;
}

// const BusinessTable: React.FC<BusinessTableProps> = ({  onRowClick }) => {
//   const businesses = useSelector((state:any) => state.Business.businesses); 
//   const dispatch =useDispatch();
//   const formatPhoneForWhatsApp = (phone: any) => phone.replace(/\D/g, "");


  
//     const handleToggleIsShow = async (id: number) => {
//       try {
//         await dispatch<any>(toggleIsShow(id));
 
//       } catch (err) {
//         console.error("Error toggling isShow", err);
//       }
//     };
  
//   return (
//     <table className="business-table">
//       <thead>
//         <tr>
//           <th>לוגו</th>
//           <th>שם העסק</th>
//           <th>שם בעל העסק</th>
//           <th>אימייל</th>
//           <th>טלפון</th>
//           <th>דוחות</th>
//           <th>צ׳אט</th>
//           <th>חסום עסק</th>
//         </tr>
//       </thead>
//       <tbody>
//         {businesses.map((biz:any) => (
//           <tr key={biz.id} onClick={() => onRowClick(biz)} className="clickable-row">
//             <td><img src={biz.uploadLogo || ''} alt="logo" className="biz-logo" /></td>
//             <td>{biz.name}</td>
//             <td>{biz.nameOfOwner}</td>
//             <td>{biz.email}</td>
//             <td>{biz.phone}</td>
//             <td>
//               <button className="report-btn">חשבון</button>
//             </td>
//             <td>
//               <button className="whatsapp-btn">
//               <a
//                 className="btn btn-success"
//                 href={`https://wa.me/${formatPhoneForWhatsApp(biz.phone)}`}
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <img src={whatsApp} alt="Logo"/>
//               </a>
//               </button>
//             </td>
// <td>
//   <img
//     className='logo-bt'
//     src={biz.isShow ? unblocked : blocked}
//     alt="Toggle"
//     style={{ cursor: "pointer", width: "40px", height: "40px" }}
//     onClick={(e) => {
//       e.stopPropagation(); // מונע פתיחת הטופס
//       handleToggleIsShow(biz.id);
//     }}
//   />
// </td>
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   );
// };

interface BusinessTableProps {
  onRowClick: (business: Business) => void;
  businesses: Business[]; // נקבל עסקים מוכנים מהאב
}

const BusinessTable: React.FC<BusinessTableProps> = ({ onRowClick, businesses }) => {
  const dispatch = useDispatch();

  const formatPhoneForWhatsApp = (phone: any) => phone.replace(/\D/g, "");

  const handleToggleIsShow = async (id: number) => {
    try {
      await dispatch<any>(toggleIsShow(id));
    } catch (err) {
      console.error("Error toggling isShow", err);
    }
  };

  return (
    <table className="business-table">
      <thead>
        <tr>
          <th>לוגו</th>
          <th>שם העסק</th>
          <th>שם בעל העסק</th>
          <th>אימייל</th>
          <th>טלפון</th>
          <th>דוחות</th>
          <th>צ׳אט</th>
          <th>חסום עסק</th>
        </tr>
      </thead>
      <tbody>
        {businesses.map((biz:any) => (
          <tr key={biz.id} onClick={() => onRowClick(biz)} className="clickable-row">
            <td>
              <img src={biz.uploadLogo ? `${process.env.REACT_APP_IMAGE_BASE_URL}${biz.uploadLogo}` : ''} 
                alt="logo" className="biz-logo" /></td>
            <td>{biz.name}</td>
            <td>{biz.nameOfOwner}</td>
            <td>{biz.email}</td>
            <td>{biz.phone}</td>
            <td><button className="report-btn">חשבון</button></td>
            <td>
              <a href={`https://wa.me/${formatPhoneForWhatsApp(biz.phone)}`} target="_blank" rel="noopener noreferrer">
                <img src={whatsApp} alt="Logo"/>
              </a>
            </td>
            <td>
              <img
                className='logo-bt'
                src={biz.isShow ? unblocked : blocked}
                alt="Toggle"
                style={{ cursor: "pointer", width: "40px", height: "40px" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleToggleIsShow(biz.id);
                }}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default BusinessTable;
